import { createMappedEntityAdapter, type MappedEntityAdapter, type MappedEntityState } from '@/utils/store/store-map.utils';
import type { Category } from '../../../interfaces/Category.interface';

export enum MapKey {
    BY_RESOURCE_TYPE = 'byResourceType',
    BY_PROJECT_ID = 'byProjectId'
}

export const categoryAdapter: MappedEntityAdapter<Category, MapKey> = createMappedEntityAdapter({
    selectId: category => category.categoryId,
    mapDefinitions: [
        { selectMapId: category => category.resourceType, mapName: MapKey.BY_RESOURCE_TYPE },
        {
            selectMapId: category => category.projectId,
            mapName: MapKey.BY_PROJECT_ID
        }
    ],
    sortComparer: (category1, category2) => category1.rank - category2.rank
});

export interface State extends MappedEntityState<Category> {
    isPending: boolean;
    isLoaded: boolean;
}

export const initialState: State = categoryAdapter.getInitialState({
    isPending: false,
    isLoaded: false
});
